import { useQuery } from "react-query";
import { getChamberUsers } from "./gateway";

export default function useGetChamberUsers(enabled: boolean) {
  return useQuery({
    queryFn: getChamberUsers,
    queryKey: "chamber-users",
    enabled: enabled,
  });
}
